export function timeout(millis: number): Promise<void> {
	return new Promise((res) => window.setTimeout(res, millis));
}

export function defer(): Promise<void> {
	return timeout(0);
}

export function getInputUndLabel($container: JQuery<HTMLElement>, id: string) {
	return {
		label: $container.find<HTMLLabelElement>(`label[for="${id}"]`),
		input: $container.find<HTMLInputElement>(`#${id}`)
	};
}

export function replaceHash(newhash: string) {
	if (("" + newhash).charAt(0) !== "#") {
		newhash = "#" + newhash;
	}

	history.replaceState("", "", newhash);
}
